<div 
  class="dropzone" 
  [ngStyle]="{'height': height, 'width': width}"
  (dragover)="onDragOver($event)" 
  (drop)="onDrop($event)"
  (dragleave)="onDragLeave($event)"
  (click)="onDropzoneClick()"
  [class.dragover]="isDragOver">
  <input 
    #fileInput
    class="file-input" 
    type="file" 
    [attr.accept]="fileTypes"
    multiple 
    (change)="onFileSelected($event)" />
  <div class="file-list">
    @if (files.length === 0) {
        <div class="dropzone-text">
            Drag and drop files here or click to upload
        </div>
    } @else {
        @for (file of files; track $index) {
            <span class="badge" [class.text-bg-light]="!isFileInvalid(file)" [class.text-bg-warning]="isFileInvalid(file)">
                {{ file.name }}
                @if(!lockdown){
                  <i class="bi bi-x-circle cursor-pointer" (click)="removeFile($index, $event)"></i>
                }
            </span>
        }
    }
    @if (invalidFiles.length > 0) {
        <div class="invalid-file-warning">
            Unsupported file type selected: {{ invalidFileNames }}. Accepted file types: {{ fileTypes }}.
        </div>
    }
  </div>
</div>
